import React from 'react';
import './notification-content.scss';

const Notification = ({ notificationTitle, notificationText }) => {

  let titleText = <div className="notification-heading">{notificationTitle}</div>;
  let contentText = <div className="notification-content-block">{notificationText}</div>;

  return (
    <div>
      {titleText}
      {contentText}
    </div>
  );
};

export default Notification;